import { t } from 'i18next';

import { ContextMenuItem } from '../../../../react/components/skyview/context-menu';
import { userStateAdapter } from '../../../../react/state/user-state/user-state-adapter';
import { publishNotification } from '../../../../utils/notifications/publish-notification';
import { textUtils } from '../../../../utils/text/text';
import { isDefined } from '../../../../utils/variables';
import { AssetManager } from '../../../asset-manager';
import { AssetVisibilityManager } from '../../../asset-visibility-manager';
import { Design } from '../../../elements/design';
import { ElementObj } from '../../../elements/element-obj';
import { Point3d } from '../../../utilities/math-helpers';
import { DesignTool } from '../../design-tool';
import { Tool } from '../../tool';

export const option = (
  condition: boolean,
  buildAction: () => ContextMenuItem,
): ContextMenuItem[] => (condition ? [buildAction()] : []);

export const copyCoordinate = (
  coordinate: Point3d,
  finishedCallback?: () => void,
): ContextMenuItem => {
  return {
    title: t('contextMenu.copyCoordinate', { ns: 'skyviewDesign' }),
    action: async () => {
      textUtils.copyTextToClipboard(`${coordinate.y}\t${coordinate.x}\t${coordinate.z}`);
      publishNotification('succ0903');
      finishedCallback?.();
      return Promise.resolve();
    },
    hotkey: 'Ctrl + C',
  };
};

export const deselectAsset = (finishedCallback?: () => void): ContextMenuItem => {
  return {
    title: t('contextMenu.deselect', {
      ns: 'skyviewDesign',
    }),
    action: async () => {
      AssetManager.instance.select(undefined);
      finishedCallback?.();
      return Promise.resolve();
    },
    disabled: !isDefined(AssetManager.instance.getSelected()),
  };
};

export const toggleAsset = (asset: ElementObj, finishedCallback?: () => void): ContextMenuItem => {
  const visible = asset.getStateVisibility();
  return {
    title: visible
      ? t('contextMenu.hide', {
          ns: 'skyviewDesign',
          name: asset.name,
        })
      : t('contextMenu.show', {
          ns: 'skyviewDesign',
          name: asset.name,
        }),
    action: async () => {
      void AssetVisibilityManager.getInstance().toggleAsset(asset.uuid, !visible, false);
      finishedCallback?.();
      return Promise.resolve();
    },
    disabled: asset.loadingStatus === 'loading',
  };
};

export const editAsset = (
  tool: Tool,
  asset: ElementObj,
  finishedCallback?: () => void,
): ContextMenuItem => {
  return {
    title: t('contextMenu.edit', { ns: 'skyviewDesign' }),
    action: async () => {
      tool.inputHandler.setTool('design');
      const editorTool = tool.inputHandler.currentTool();

      if (editorTool instanceof DesignTool && asset instanceof Design) {
        AssetManager.instance.select(asset);
        // void editorTool.onInitiate(asset);
      }

      finishedCallback?.();
      return Promise.resolve();
    },
    disabled: !userStateAdapter.getSnapshot().hasDesignToolAccessForCurrentProject(),
  };
};
